const QUERY_PARAMS = {
    CONNECTION_TYPE: 'p',
    DEVICE_TYPE: 'd',
    CODENTIFY: 'id',
    QR_TYPE: 't',
    SOURCE_TYPE: 's',
    EVENT_TYPE: 'event',
    GEO_RESTRICTION: 'gr',
    BROWSER_CHECK: 'bc',
};

export default QUERY_PARAMS;
